import { Component, Output, EventEmitter } from "@angular/core";
import { FileTransfer } from "@ionic-native/file-transfer";
import { Platform } from "ionic-angular";

@Component({
    selector: "file-input",
    templateUrl: "file-input.html",
})
export class FileInputComponent {
    fileName: string = "Nenhum arquivo enviado";
    @Output() onFileChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(public fileTransfer: FileTransfer, public platform: Platform) {}

    changeFile(event: any) {
        console.log("a");
        let file = event.target.files[0];
        this.fileName = file.name;

        console.log(file);
        this.onFileChange.emit(file);
    }

    isAndroid() {
        console.log(this.platform.is("android"));
        return this.platform.is("android");
    }
}



// WEBPACK FOOTER //
// ./src/components/file-input/file-input.ts